import React from "react";
import Icon from "components/AppIcon";
import { getClientsService } from "redux/services/clients_service";
import { useDispatch } from "react-redux";
import { getTrainersService } from "redux/services/trainers_service";

const FilterToolbar = ({ filters, onFiltersChange ,language }) => {
  const dispatch = useDispatch();

  const handleStatusChange = (e) => {
    onFiltersChange((prev) => ({ ...prev, status: e.target.value }));
  };

  const handleDateRangeChange = (field, value) => {
    onFiltersChange((prev) => ({
      ...prev,
      dateRange: { ...prev.dateRange, [field]: value },
    }));
  };

  const clearFilters = () => {
    onFiltersChange({
      search: "",
      status: "All",
      dateRange: { start: "", end: "" },
    });
  };

  const handleSearch = (val) => {
    dispatch(getTrainersService({ search: val }));
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex flex-col sm:flex-row gap-4 flex-1">

              {/* Search Input */}
          <div className="relative flex-1 max-w-md">
            <div
              className={`absolute inset-y-0 ${
                language === "ar" ? "right-0 pr-3" : "left-0 pl-3"
              } flex items-center pointer-events-none`}
            >
              <Icon name="Search" size={20} className="text-gray-400" />
            </div>
            <input
              type="text"
            //  placeholder={t.searchPlaceholder}
            onChange={(e) => handleSearch(e.target.value)}
              className={`py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent ${
                language === "ar" ? "pr-10 pl-4 text-right" : "pl-10 pr-4"
              }`}
            />
          </div>
       
        </div>
      </div>
    </div>
  );
};

export default FilterToolbar;
